import { Component, inject } from '@angular/core'
import { SystemConfigService } from '@client/Services/SystemConfigService'
import { PaymentPlanComponent as GoCardlessPaymentPlan } from '@client/Components/Orders/Order/PaymentPlans/Gocardless/PaymentPlan.Component'

@Component({
	selector: 'order-payment-plan',
	templateUrl: './PaymentPlan.Component.html',
	imports: [GoCardlessPaymentPlan],
})
export class PaymentPlanComponent {
	protected readonly systemConfigService: SystemConfigService

	constructor() {
		this.systemConfigService = inject(SystemConfigService)
	}
}
